// --------------------------------------------------------------
// Created On: 2025-04-01
// Author: Hannah Vaughan
//
// Last Modified: 2025-04-07
// Modified By: Hannah Vaughan
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import PropTypes from "prop-types";
import styles from "./SpeedChangeControls.module.scss";
import SpeedChangeButton from "./SpeedChangeButton/SpeedChangeButton";
import PanelSection from "../PanelSection/PanelSection";

// Container for all speed change button controls in the Speed Change section of the Remote Operation Panel.
export default function SpeedChangeControls(props: Props): Component {
  return (
    <PanelSection label="Speed Change">
      {props.defaultSpeeds.map((speed) => (
        <div className={`col-6 col-lg-3 px-3 ${styles.controlColumn}`} key={speed}>
          <SpeedChangeButton
            rpmValue={speed}
            showHertz={false}
            disabled={props.loading}
            onClick={(rpm) => props.onChangeSpeed(rpm)}
          />
        </div>
      ))}
    </PanelSection>
  );
}

SpeedChangeControls.propTypes = {
  loading: PropTypes.bool.isRequired,
  defaultSpeeds: PropTypes.array.isRequired,
  onChangeSpeed: PropTypes.func.isRequired,
};

interface Props {
  loading: boolean;
  defaultSpeeds: number[];
  onChangeSpeed: (rpm: number) => void;
}
